const locale = 'ES-es'

export const FormatDate = (date) => {
  if (date === null) return ''

  const dateObject = new Date(date)
  return (
    ('0' + dateObject.getDate()).slice(-2) +
    '/' +
    ('0' + (dateObject.getMonth() + 1)).slice(-2) +
    '/' +
    dateObject.getFullYear() +
    ' ' +
    ('0' + dateObject.getHours()).slice(-2) +
    ':' +
    ('0' + dateObject.getMinutes()).slice(-2) +
    ':' +
    ('0' + dateObject.getSeconds()).slice(-2)
  )
}
export const FormatDateNoTime = (date) => {
  if (date === null) return ''

  const dateObject = new Date(date)
  return (
    ('0' + dateObject.getDate()).slice(-2) +
    '/' +
    ('0' + (dateObject.getMonth() + 1)).slice(-2) +
    '/' +
    dateObject.getFullYear()
  )
}
export const FormatDateNoSeconds = (date) => {
  if (date === null) return ''

  const dateObject = new Date(date)
  return (
    ('0' + dateObject.getDate()).slice(-2) +
    '/' +
    ('0' + (dateObject.getMonth() + 1)).slice(-2) +
    '/' +
    dateObject.getFullYear() +
    ' ' +
    ('0' + dateObject.getHours()).slice(-2) +
    ':' +
    ('0' + dateObject.getMinutes()).slice(-2)
  )
}

export const FormatMoney = (number, fallback = '', customFallbackCondition = false) => {
  if (number === null || number === undefined || customFallbackCondition) return fallback

  return number.toLocaleString(locale, {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2
  })
}
export const FormatKilograms = (number, fallback = '', customFallbackCondition = false) => {
  if (number === null || number === undefined || customFallbackCondition) return fallback

  return `${number.toLocaleString(locale, { maximumFractionDigits: 2, minimumFractionDigits: 2 })} Kg`
}

export function addZero(i) {
  if (i < 10) {
    i = '0' + i
  }
  return i
}

export function base64toBlob(base64Data, contentType) {
  contentType = contentType || ''
  var sliceSize = 1024
  var byteCharacters = atob(base64Data)
  var bytesLength = byteCharacters.length
  var slicesCount = Math.ceil(bytesLength / sliceSize)
  var byteArrays = new Array(slicesCount)

  for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
    var begin = sliceIndex * sliceSize
    var end = Math.min(begin + sliceSize, bytesLength)

    var bytes = new Array(end - begin)
    for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
      bytes[i] = byteCharacters[offset].charCodeAt(0)
    }
    byteArrays[sliceIndex] = new Uint8Array(bytes)
  }
  return new Blob(byteArrays, { type: contentType })
}
